import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Observable, pipe, timer } from "rxjs";
import { scan, takeWhile } from "rxjs/operators";

@Component({
    selector: "ep-session-expiry-dialog",
    templateUrl: "./session-expiry-dialog.component.html",
    standalone: false
})
export class SessionExpiryDialogComponent implements OnInit {
  timer$: Observable<number>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<SessionExpiryDialogComponent>,
  ) {}

  ngOnInit() {
    this.timer$ = timer(0, 1000).pipe(
      scan((acc) => --acc, 30),
      takeWhile((x) => x >= 0),
    );

    this.timer$.subscribe((x) => {
      if (x === 0) {
        this.dialogRef.close({ continue: false });
      }
    });
  }

  continue() {
    this.dialogRef.close({ continue: true });
  }
}
